import cls from "./AdminTurnControlPanel.module.scss";

export default function AdminTurnControlPanel({
  turnView,
  onNextTurn,
  onCompleteResult,
  loading,
}) {
  const liveState = turnView?.liveState || {};
  const turn = turnView?.turn || null;

  const round = liveState?.currentRound || 1;
  const livePhase = liveState?.phase || "lobby";
  const turnPhase = liveState?.turnPhase || "idle";

  const answerPlayer = turnView?.players?.answerPlayer?.displayName || "-";
  const guessPlayer = turnView?.players?.guessPlayer?.displayName || "-";

  const canCreateTurn = !loading && !turn;
  const canCompleteTurn = !loading && turn?.status === "result_ready";

  return (
    <section className={cls.panel}>
      <div className={cls.panelGlowPink} />
      <div className={cls.panelGlowBlue} />
      <div className={cls.scanLines} />

      <div className={cls.header}>
        <div className={cls.headerText}>
          <p className={cls.kicker}>ADMIN CONTROL</p>
          <h3 className={cls.title}>Sprint 3 Turn Control</h3>
          <p className={cls.subtitle}>
            Manage the next live turn and open post-result penalty stage from
            one place.
          </p>
        </div>

        <div className={cls.statusStack}>
          <span className={cls.liveBadge}>LIVE</span>
        </div>
      </div>

      <div className={cls.statsGrid}>
        <article className={cls.statCard}>
          <span className={cls.statLabel}>ROUND</span>
          <strong className={cls.statValue}>{round}</strong>
        </article>

        <article className={cls.statCard}>
          <span className={cls.statLabel}>LIVE PHASE</span>
          <strong className={cls.statValueCap}>{livePhase}</strong>
        </article>

        <article className={cls.statCard}>
          <span className={cls.statLabel}>TURN PHASE</span>
          <strong className={cls.statValueCap}>{turnPhase}</strong>
        </article>
      </div>

      <div className={cls.playerBoard}>
        <article className={cls.playerCard}>
          <span className={cls.playerRole}>ANSWER PLAYER</span>
          <strong className={cls.playerName}>{answerPlayer}</strong>
        </article>

        <div className={cls.vsBadge}>VS</div>

        <article className={cls.playerCard}>
          <span className={cls.playerRole}>GUESS PLAYER</span>
          <strong className={cls.playerName}>{guessPlayer}</strong>
        </article>
      </div>

      <div className={cls.turnState}>
        <span className={cls.turnStateLabel}>Current Turn</span>
        <strong className={cls.turnStateValue}>
          {turn?._id ? "Turn Active" : "No Active Turn"}
        </strong>
      </div>

      <div className={cls.buttonRow}>
        <button
          type="button"
          className={`${cls.actionButton} ${cls.primaryButton}`}
          onClick={onNextTurn}
          disabled={!canCreateTurn}
        >
          {loading ? "Loading..." : "Create Next Turn"}
        </button>

        <button
          type="button"
          className={`${cls.actionButton} ${cls.secondaryButton}`}
          onClick={() => onCompleteResult(turn?._id)}
          disabled={!canCompleteTurn}
        >
          {loading ? "Loading..." : "Open Penalty Stage"}
        </button>
      </div>
    </section>
  );
}
